<template>
    <div>
        <div class="row infoBox">
            <div class="col-sm-7 pt-0 pb-20">
                <div class="tabs-container">
                    <button v-for="(student, index) of students"
                            type="button"
                            class="btn btn-link"
                            @click="changeTab(student.id, index)"
                            :class="{'is-active': index === tabActive}"
                            :key="index"
                    >
                        <span>{{ studentName(student.first_name, student.last_name) }}</span>
                    </button>
                </div>
            </div>
            <div class="col-sm-5 pt-0 search-full pb-20">
                <app-search-form :placeholder="$t('search_curator_teacher')" class="chat-head__search--white"></app-search-form>
            </div>
        </div>
<!--        <div v-for="item of curators.curators">-->
<!--            {{ item }}-->
<!--        </div>-->
        <vue-custom-scrollbar class="scroll-area calcHeight scroll-area--mb"
                              :settings="settingsHorizontal"
        >
            <div v-if="curators" class="row infoBox" >
                <div class="col-sm-12">
                    <h4><b>{{ $t('curator')}}</b></h4>
                 </div>
             </div>
            <app-member-list
                v-for="(item, index) of curators"
                :viewCurator="true"
                :member="item"
                :key="index"
            >
            </app-member-list>
            <div v-if="teachers" class="row infoBox">
                <div class="col-sm-12">
                   <h4><b>{{ $t('teachers')}}</b></h4>
                 </div>
             </div>
            <div class="teachers-list">
                <app-member-list
                    v-for="(item, index) of teachers"
                    :viewTeacher="true"
                    :member="item"
                    :key="index"
                ></app-member-list>
            </div>
            <template v-if="teachers.length === 0">
                <div class="text-center my-20">
                    {{ $t('nothing_found') }}
                </div>
            </template>
        </vue-custom-scrollbar>
    </div>
</template>


<script>
    import { mapGetters } from 'vuex';
    import env from "../../env";
    import SearchForm from "../../courses/components/SearchForm";
    import MemberList from "./MemberList"
    import vueCustomScrollbar from 'vue-custom-scrollbar';


    export default {
        data: () => ({
            tabActive: 0,
            currentStudentId: null,
            settingsHorizontal: {
                maxScrollbarLength: 60,
                swipeEasing: true,
                suppressScrollY: false
            },
        }),
        components: {
            appMemberList: MemberList,
            appSearchForm: SearchForm,
            vueCustomScrollbar: vueCustomScrollbar,
        },
        computed: {
            ...mapGetters([
                'search_value',
                'userData',
                'students_payer',
                'teachers_payer',
                'curators_payer'
            ]),
            students() {
                return this.students_payer && typeof this.students_payer === 'object' ? this.students_payer : false
            },
            teachers() {
                return this.search_value && this.search_value.length > 0 ? this.teachers_payer.filter(el => {
                    return el.last_name.toLowerCase().indexOf(this.search_value.toLowerCase()) > -1 ||
                        el.first_name.toLowerCase().indexOf(this.search_value.toLowerCase()) > -1 ||
                        el.patronymic.toLowerCase().indexOf(this.search_value.toLowerCase()) > -1
                }) : this.teachers_payer;
            },
            curators() {
                return this.curators_payer && typeof this.curators_payer === 'object' ? this.curators_payer : false
            }
        },
        methods: {
            studentName(firstName, lastName) {
                return firstName + ' ' + lastName;
            },
            changeTab(id, index) {
                this.tabActive = index;
                this.$store.dispatch('GET_PAYER_TEACHERS', id);
                this.$store.dispatch('GET_PAYER_CURATORS', id);
                this.currentStudentId = id;
                this.$route.params.child_id = id;
                this.pushToUrl(id, 'student');
            },
            pushToUrl(val, param) {
                let url = new URL(window.location);
                if (url.searchParams.get(param) === null) {
                    url.searchParams.append(param, val)
                } else {
                    url.searchParams.set(param, val)
                }
                if (val === '') {
                    url.searchParams.delete(param)
                }
                window.history.pushState({path: url.href}, '', url.href);
            },
        },
        created() {
            let searchParams = (new URL(document.location)).searchParams;
            if (searchParams.has('student')) {
                this.currentStudentId = searchParams.get('student');
                this.$route.params.child_id = searchParams.get('student');
                this.changeTab(+searchParams.get('student'), this.students_payer.findIndex((e, i) => e.id === +searchParams.get('student')));
            } else {
                this.currentStudentId = this.students[0].id;
                this.$route.params.child_id = this.students[0].id;
                this.pushToUrl(this.students[0].id, 'student');
                this.$store.dispatch('GET_PAYER_TEACHERS', this.students[0].id);
                this.$store.dispatch('GET_PAYER_CURATORS', this.students[0].id);
            }
        }
    }
</script>

<style scoped lang="sass">
    @import "../../../sass/variables"
    @import "../../../sass/cabinet"
    @import "../../../sass/teacherLesson"
    @import "../../../sass/teacherCheckwork"
    @import "../../../sass/studentStat"
    @import "../../../sass/teacherMaterials"
    @import "../../../sass/payer"

    .pt-0
        padding-top: 0

    .pb-0
        padding-bottom: 0

    .pb-20
        padding-bottom: 20px

    .my-20
        margin: 20px 0

    .search__input
        background: $white

    .diary-navigation
        display: flex
        align-items: center
        justify-content: space-between

        .chat-head__search
            margin-left: 20px

    .teachers-list
        display: flex
        flex-wrap: wrap
        margin: 0 10px

        .member-wrap
            padding: 0 10px
            flex: 0 0 50%
            max-width: 50%

    .search-full

        .chat-head__search
            width: calc(100% - 5px)
</style>